import classnames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import config from "../../../../application/config/config";
import Fetch from "../../../util/core/Fetch";
import { getUserSession } from "../../../util/core/Session";
import CustomForm from "../Util/Form/CustomForm/CustomForm";
import CustomFormContainer from "../Util/Form/CustomForm/CustomFormContainer";
import TreeView from "./PermissionTreeview";
import TreeViewMobile from "./PermissionTreeviewMobile";
import { CheckIfIsViewScreen } from "../../../util/core/CheckIfIsViewScreen";
import sleep from "sleep-promise";

function Form() {
  const session = getUserSession();
  const { id } = useParams();
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.session);
  const [activeTab, setActiveTab] = useState("tree");
  const [permission, setPermission] = useState([]);
  const [permissionMobile, setPermissionMobile] = useState([]);
  const [allPermissions, setAllPermissions] = useState([]);
  const [allPermissionsMobile, setAllPermissionsMobile] = useState([]);
  const navigate = useNavigate();
  const isView = CheckIfIsViewScreen();
  const endpointBackend = config.endpoints.backend;
  const path = "/core/applicationsprofiles/";
  const paths = {
    endpointSave: endpointBackend + "core/applicationsprofiles/save",
    endpointGetById: endpointBackend + "core/applicationsprofiles/getById",
    urlGoBack: path + "list",
    pathView: path + "view",
  };

  const labels = {
    labelTitleAdd: "Novo Perfil de acesso",
    labelTitleEdit: "Editar Perfil de acesso",
    labelTitleView: "Visualizar Perfil de acesso",
  };

  const hiddenValuesToForm =
    session.user.application_id == config.admin_application_id
      ? {}
      : { application_id: session.user.application_id };

  function addPropertiesRecursive(array) {
    return array.map((item) => {
      const newItem = { ...item };
      newItem.canViewMenu = true;
      newItem.canView = true;
      newItem.canAdd = true;
      newItem.canEdit = true;
      newItem.canDelete = true;
      newItem.canInactivate = true;

      if (newItem.children && newItem.children.length > 0) {
        newItem.children = addPropertiesRecursive(newItem.children);
      }

      return newItem;
    });
  }

  function addPropertiesRecursiveMobile(array) {
    return array.map((item) => {
      const newItem = { ...item };
      newItem.canViewMenu = true;

      if (newItem.children && newItem.children.length > 0) {
        newItem.children = addPropertiesRecursiveMobile(newItem.children);
      }

      return newItem;
    });
  }

  let permissionFormsType = useSelector((state) => { return state.session.permission_forms_type ? state.session.permission_forms_type : '' });

  useEffect(() => {
    dispatch({
      type: "UPDATE_SESSION",
      key: "current_permission",
      value: permission,
    });
  }, [permission]);

  useEffect(() => {
    dispatch({
      type: "UPDATE_SESSION",
      key: "current_permission_mobile",
      value: permissionMobile,
    });
  }, [permissionMobile]);

  const handleSubmit = async (fields, values, loadData) => {
    const finalPermission = selector["current_permission"];
    const finalPermissionMobile = selector["current_permission_mobile"];

    console.log({
      finalPermission,
      finalPermissionMobile,
      values
    })

    const finalValues = { ...values, permissions: finalPermission, permissions_mobile: finalPermissionMobile };
    await Fetch.put(paths.endpointSave, finalValues);
    navigate(paths.urlGoBack);
  };

  const handleChangeTreeView = async (permissions) => {
    const finalValues = { id: id, permissions: permissions };
    setPermission(permissions);
    await Fetch.put(paths.endpointSave, finalValues);
  };

  const handleChangeTreeViewMobile = async (permissions) => {
    const finalValues = { id: id, permissions_mobile: permissions };
    setPermissionMobile(permissions);
    await Fetch.put(paths.endpointSave, finalValues);
  };

  const CustomDivider = () => {
    const style = {
      borderWidth: 0,
      borderBottomWidth: 1,
      borderStyle: "solid",
      borderColor: "#cccccc",
      height: 1,
      marginBottom: 7
    }

    return (
      <div style={style}></div>
    )
  }

  const form = {
    validateOnChange: true,
    hiddenValues: {
      ...hiddenValuesToForm,
      core_application_instance_id: session.user.application_instance_id,
    },
    handleSubmit,
    fields: [
      !hiddenValuesToForm.application_id
        ? {
          name: "application_id",
          type: "select",
          label: "Aplicação",
          options: [],
          optionsEndpoint: {
            endpoint: endpointBackend + "core/applications/getall",
            label: "application_name",
            value: "id",
          },
          validations: {
            required: true,
          },
          columnSize: 12,
        }
        : {},
      {
        name: 'initial_path',
        type: 'text',
        label: 'Direcionamento inicial (login)',
        validations: {
          required: true
        },
        columnSize: 12
      },
      {
        name: "profile_name",
        type: "text",
        label: "Perfil",
        validations: {
          required: true,
        },
        columnSize: 12,
      },
      {
        name: "menu",
        type: "sortabletree",
        label: "Menu Web",
        levelsLimit: 3,
        onChangeTreeData: async (treeData) => {
          if (id) {
            const values = {
              id: id,
              menu: treeData,
            };
            await Fetch.put(paths.endpointSave, values);
          }
        },
        validations: {},
        fieldsForm: [
          {
            name: 'type',
            type: 'select',
            label: 'Tipo',
            options: [
              { label: "Menu", value: "1" },
              { label: "Ação", value: "2" },
            ],
            validations: {
              required: true
            },
            isClearable: false,
            columnSize: 12
          },
          {
            name: "title",
            type: "text",
            label: "Menu / Ação",
            validations: {
              required: true,
            },
            columnSize: 12,
          },
          {
            name: "icon",
            type: "selectIcons",
            label: "Ícone",
            validations: {
              required: false,
            },
            columnSize: 12,
          },
          {
            name: 'permission_options',
            type: 'multiselect',
            label: 'Permissionamento',
            options: [
              { label: "Visualizar", value: "canView" },
              { label: "Adicionar", value: "canAdd" },
              { label: "Editar", value: "canEdit" },
              { label: "Excluir", value: "canDelete" },
              { label: "Inativar", value: "canInactivate" },
            ],
            validations: {
              required: false
            },
            columnSize: 12
          },
          {
            name: "functionality_id",
            type: "select",
            label: "Funcionalidade",
            options: [],
            optionsEndpoint: {
              endpoint:
                endpointBackend + "core/applicationsfunctionalities/getall",
              label: "functionality",
              value: "id",
            },
            validations: {
              required: false,
            },
            columnSize: 12,
          },
          {
            name: "key",
            type: "text",
            label: "Chave",
            validations: {
              required: false,
            },
            columnSize: 12,
          },
        ],
        columnSize: 12,
      },
      {
        name: "",
        type: "customInput",
        validations: {
          required: false,
        },
        component: () => (
          <CustomDivider />
        ),
        columnSize: 12,
      },
      {
        name: "menu_mobile",
        type: "sortabletree",
        label: "Menu Mobile",
        levelsLimit: 3,
        onChangeTreeData: async (treeData) => {
          if (id) {
            const values = {
              id: id,
              menu_mobile: treeData,
            };
            await Fetch.put(paths.endpointSave, values);
          }
        },
        validations: {},
        fieldsForm: [
          {
            name: "title",
            type: "text",
            label: "Menu / Ação",
            validations: {
              required: true,
            },
            columnSize: 12,
          },
          {
            name: "key",
            type: "text",
            label: "Chave",
            validations: {
              required: true,
            },
            columnSize: 12,
          },
        ]
      },
    ],
    ...paths,
    ...labels,
  };

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "tree" })}
            onClick={() => {
              setActiveTab("tree");
            }}
          >
            Dados do Perfil
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "list" })}
            onClick={() => {
              setActiveTab("list");
            }}
          >
            Permissionamento - Web
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "listMobile" })}
            onClick={() => {
              setActiveTab("listMobile");
            }}
          >
            Permissionamento - Mobile
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="bg-white">
        <TabPane tabId="tree">
          <Col sm="12">
            <CustomFormContainer
              form={form}
              content={<CustomForm form={form} />}
            />
          </Col>
        </TabPane>
        <TabPane tabId="list">
          <Col sm="12">
            <TreeView
              disabled={isView}
              endpointGetById={paths.endpointGetById}
              addPropertiesRecursive={addPropertiesRecursive}
              permission={permission}
              setPermission={setPermission}
              allPermissions={allPermissions}
              setAllPermissions={setAllPermissions}
              handleChange={handleChangeTreeView}
            />
          </Col>
        </TabPane>
        <TabPane tabId="listMobile">
          <Col sm="12">
            <TreeViewMobile
              disabled={isView}
              endpointGetById={paths.endpointGetById}
              addPropertiesRecursive={addPropertiesRecursiveMobile}
              permission={permissionMobile}
              setPermission={setPermissionMobile}
              allPermissions={allPermissionsMobile}
              setAllPermissions={setAllPermissionsMobile}
              handleChange={handleChangeTreeViewMobile}
            />
          </Col>
        </TabPane>
      </TabContent>
    </div>
  );
}
export default Form;
